lmApp
  .service('ApiService', ['$q', '$http', function ($q, $http) {
    var service = {};

    var endpoint = '/supervisor:80/';

    var request = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      transformRequest: function (obj) {
        var str = [];
        for (var p in obj)
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        return str.join("&");
      }
    };

    service.SetToken = function (token) {
      service.token = token;
      //$http.defaults.headers.common['X-Supervisor-Token'] = token;
    };

    service.Request = function (url, method, data) {
      var deferred = $q.defer();

      if (!url) {
        deferred.reject({
          result: 0,
          message: 'No URL found'
        });
        return;
      }

      request.url = endpoint + url;
      request.data = data;
      request.headers['X-Supervisor-Token'] = service.token;

      if (method) {
        request.method = method;
      } else {
        request.method = 'GET';
      }

      $http(request)
        .then(function (response) {
          var answer = response.data;
          var status = response.status;
          var headers = response.headers;
          var config = response.config;

          if (answer.result) {
            deferred.resolve(answer);
          } else {
            answer.data = data;
            answer.url = url;
            deferred.reject(answer.error);
          }
        }, function (response) {
          var data = response.answer;
          var status = response.status;
          var headers = response.headers;
          var config = response.config;
          console.log(data, status, headers, config);
          deferred.reject(data);
        });

      return deferred.promise;
    };

    return service;
  }]);
